/** Origine publique d'`apps/app` (app.jeraisonne.fr) — retour depuis tutor.jeraisonne.fr. */
export function appUrl(): string {
  return (import.meta.env.VITE_APP_URL as string | undefined) ?? 'https://app.jeraisonne.fr';
}
